<template>
  <section id="contact" class="contactFormContainer">
    <div class="container">
      <h3 class="text-center wow fadeInDown sectionSixh3 contactHeadline ">
        {{ $t("contact_headline") }}
      </h3>
      <form id="contact-form" @submit.prevent="processForm" role="form">
        <div class="messages"></div>
        <div class="controls">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="form_name">{{ $t("contact_name") }}</label>
                <input
                  id="form_name"
                  type="text"
                  name="name"
                  class="form-control"
                  :placeholder="$t('contact_placeholder_name')"
                  required="required"
                  v-model="name"
                />
                <div class="help-block with-errors"></div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label for="form_company">{{ $t("contact_company") }}</label>
                <input
                  id="form_company"
                  type="text"
                  name="company"
                  class="form-control"
                  :placeholder="$t('contact_placeholder_company')"
                  required="required"
                  v-model="company"
                />
                <div class="help-block with-errors"></div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="form_email">{{ $t("contact_email") }}</label>
                <input
                  id="form_email"
                  type="email"
                  name="email"
                  class="form-control"
                  :placeholder="$t('contact_placeholder_email')"
                  required="required"
                  v-model="email"
                />
                <div class="help-block with-errors"></div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label for="form_country">{{ $t("contact_country") }}</label>
                <input
                  id="form_country"
                  type="text"
                  name="country"
                  class="form-control"
                  :placeholder="$t('contact_placeholder_country')"
                  required="required"
                  v-model="country"
                />
                <div class="help-block with-errors"></div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="form_message">{{ $t("contact_message") }}</label>
                <textarea
                  id="form_message"
                  name="message"
                  class="form-control"
                  :placeholder="$t('contact_placeholder_message')"
                  rows="4"
                  v-model="message"
                ></textarea>
                <div class="help-block with-errors"></div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="defaultCheck1"
                  required="required"
                  v-model="privacyPolicy"
                />
                &nbsp;&nbsp;<label class="form-check-label" for="defaultCheck1">
                  <a
                    href="https://www.erbe-med.com/fileadmin/pdf/company/Information_On_Data_Protection_EN.pdf"
                    target="_blank"
                  >
                    {{ $t("footer_policy") }}</a
                  >{{ $t("accepted") }}
                </label>
                <div class="help-block with-errors"></div>
              </div>
            </div>
          </div>
          <div class="row sendingpromptContainer">
            <div class="col-md-12 text-center">
              <SendingPrompt
                promptType="sending"
                :message="$t('contact_sending')"
                v-show="sendInProgess"
              />
              <input
                v-show="!sendInProgess"
                type="submit"
                class="btn btn-success btn-send btn-lg"
                name="submitButton"
                :value="$t('contact_button')"
              />
            </div>
          </div>
          <div class="row sendingpromptContainer">
            <SendingPrompt
              promptType="success"
              :message="$t('contact_success')"
              v-show="!sendInProgess && isSuccess"
            />
          </div>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import SendingPrompt from "./SendingPrompt";
import { postContactForm } from "@/services/http/httpService.js";
import { isOnline } from "@/services/http/httpService.js";

export default {
  name: "ContactSection",
  components: {
    SendingPrompt
  },
  data: function() {
    return {
      name: "",
      company: "",
      email: "",
      country: "",
      message: "",
      privacyPolicy: false,
      sendInProgess: false,
      isSuccess: false,
      isFailure: false
    };
  },
  methods: {
    processForm: async function() {
      const online = await isOnline();
      if (!online) {
        this.showFailure(this.$i18n.t("contact_failure_connection"));
        return;
      }
      this.sendInProgess = true;
      var result = await postContactForm(
        this.name,
        this.company,
        this.email,
        this.country,
        this.message
      );
      this.sendInProgess = false;
      const { success } = result;

      if (success) {
        this.showSuccess();
      } else {
        this.showFailure(this.$i18n.t("contact_failure"));
      }
    },

    showSuccess: function() {
      this.isSuccess = true;
      setTimeout(() => {
        this.isSuccess = false;
      }, 7000);
    },
    showFailure: function(message) {
      window.alert(message);
    }
  }
};
</script>

<style scoped>
.contactFormContainer {
  padding-top: 50px;
}

.contactHeadline {
  font-family: "Netto Black";
  visibility: visible;
}

.sendingpromptContainer {
  margin-bottom: 30px;
}
</style>
